<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <!-- Page Content -->
    <div class="content container-fluid">
      <!-- Page Header -->
      <activity-header :title="title" :path="path" :text1="text1" />
      <!-- /Page Header -->

      <!-- Search Filter -->
      <activity-filter :getSelectedValues="getSelectedUsers" :initialType="type" :initialUsers="selectedUsersFromFilter"></activity-filter>
      <!-- /Search Filter -->


      <div class="row">
        <div class="col-md-12">
          <div class="showentries mb-3 custom-select">
            <div class="d-flex align-items-center gap-2"><span>Show</span>
              <select v-model="perPage" @change="current = 1; getActivity()" style="outline: none">
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="150">150</option>
                <option value="200">200</option>
              </select>
              <span>entries</span>
            </div>
          </div>
          <div v-if="!loader">
            <div class="table-responsive">

              <a-table class="stripped table-hover" :columns="columns" :data-source="usersData"
                :pagination="false" v-if="usersData.length" :scroll="{ x: 1420 }">
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'image_path'">
                    <h2 class="table-avatar">
                      <a href="javascript:;" class="avatar" @click="openImagePreview(record)">
                        <img :src="getImage(record.image_path)" alt="User Image" v-if="record.image_path" />
                        <img src="../../../assets/img/avatar/avatar-29.png" alt="User Image" v-else />
                      </a>
                    </h2>
                  </template>
                  <template v-else-if="column.key === 'name'">
                    <h5 class="table-avatar mb-0">
                      <div v-if="record.user_id">
                        <!-- <router-link :to="{ name: 'EmployeeProfile', params: { id: record.user_id } }">{{
                        record[getDynamicKey(record)]
                          ? `${record[getDynamicKey(record)].first_name} ${record[getDynamicKey(record)].last_name}`
                          : '--'
                        }}</router-link> -->
                        <action-dropdown @banked-time="bankedTimeClicked"
                          variant="activity"
                          :employee="{ ...record.user, name: `${record.user.first_name} ${record.user.last_name}`, id: record.user_id, account_type: record.user.account_type }"
                          :reportAsEvent="true"
                          @edit="editClicked"
                          @leaves="leavesClicked"
                          @attendance="attendanceClicked"
                          @sick-leave="sickLeaveClicked"
                          @add-face-template="addFaceTemplateClicked"
                          @face-templates="faceTemplatesClicked"
                          @toggle-monitoring="monitorClicked"
                          @report="viewReport"
                          @reset-password="resetPasswordClicked"
                          @assign-employee="assignEmployeeClicked"
                        />
                      </div>
                      <div v-else class="text-truncate" style="max-width: 175px;" :title="record[getDynamicKey(record)] ? `${record[getDynamicKey(record)].first_name} ${record[getDynamicKey(record)].last_name}` : ''">
                        {{
                          record[getDynamicKey(record)]
                            ? `${record[getDynamicKey(record)].first_name} ${record[getDynamicKey(record)].last_name}`
                            : '--'
                        }}
                      </div>

                    </h5>
                  </template>
                  <template v-else-if="column.key === 'User'">
                    <div v-if="getDynamicKey(record) === 'Unrecognized'">
                      <span class="text-danger">{{ getDynamicKey(record) }}</span>
                    </div>
                    <div v-else>
                      {{ getDynamicKey(record) === "user" ? 'Employee' : capitalizeFirstLetter(getDynamicKey(record)) }}
                    </div>

                  </template>
                  <template v-else-if="column.key === 'type'">
                    {{ getActivityTypeLabel(record.type) }}
                  </template>
                  <template v-else-if="column.key === 'location'">
                    {{ getLocationName(record.location_id) }}
                  </template>
                  <template v-else-if="column.key === 'accepted_banked_time'">



                    {{ record.accepted_banked_time ? record.accepted_banked_time : 0 }}

                  </template>
                  <template v-else-if="column.key === 'is_manually_edited'">
                    {{ record.is_manually_edited ? 'Yes' : 'No' }}
                  </template>
                  <template v-else-if="column.key === 'reason'">
                    {{ record.reason ? record.reason : '--' }}
                  </template>
                  <template v-else-if="column.key === 'updated_by'">
                    {{ record.updated_by_user ? (record.updated_by_user.first_name + ' ' + record.updated_by_user.last_name) : (record.updated_by && record.updated_by.first_name ? (record.updated_by.first_name + ' ' + record.updated_by.last_name) : (record.updated_by ? record.updated_by : '--')) }}
                  </template>
                  <template v-else-if="column.key === 'updated_at'">
                    {{ record.is_manually_edited && record.updated_at ? record.updated_at : '--' }}
                  </template>

                  <template v-else-if="column.key === 'action'">

                    <!-- class="text-end" -->
                    <div class="dropdown dropdown-action">
                      <a href="javascript:;" class="action-icon dropdown-toggle" data-bs-toggle="dropdown"
                        aria-expanded="false"><i class="material-icons">more_vert</i></a>
                      <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal"
                          data-bs-target="#edit_activity" @click="editActivityClicked(record)"><i
                            class="fa-solid fa-pencil m-r-5"></i>Edit</a>
                        <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal"
                          data-bs-target="#show_location" @click="showLocationClick(record)"><i
                            class="fa-solid fa-location-arrow m-r-5"></i>Show Location</a>
                        <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal"
                          data-bs-target="#add_user_id_face_template" @click="addUserIdFace(record)"><i
                            class="fa-solid fa-plus m-r-5"></i>Add Face</a>
                        <a v-if="getDynamicKey(record) === 'contractor'" class="dropdown-item" href="javascript:;"
                          @click="downloadPdf(record)">
                          <span v-if="!load"> <i class="fa-solid fa-download m-r-5"></i>
                            Download</span>

                          <div class="d-flex justify-content-center text-center" v-else>
                            <div class="spinner-border spinner-border-sm" role="status">
                              <span class="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        </a>
                        <a v-if="getDynamicKey(record) === 'visitor'" class="dropdown-item" href="javascript:;"
                          @click="downloadVisitorPdf(record)">
                          <span v-if="!visitorPdfLoad"> <i class="fa-solid fa-download m-r-5"></i>
                            Download</span>

                          <div class="d-flex justify-content-center text-center" v-else>
                            <div class="spinner-border spinner-border-sm" role="status">
                              <span class="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        </a>
                        <a v-if="isAdmin" class="dropdown-item" href="javascript:;"
                          @click="confirmDeleteActivity(record)">
                          <i class="fa-solid fa-trash m-r-5"></i>Delete
                        </a>
                      </div>
                    </div>
                  </template>
                </template>
              </a-table>
              <div v-else>
                <div class="card text-center">
                  <div class="card-body">
                    <img src="../../../assets/img/avatar/no-data.png" alt="no-data" srcset="" class="responsive-img">
                    <p>No employee have been added.</p>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center">
                <a-pagination v-model:current="current" v-model:pageSize="perPage" :total="total" @change="getActivity"
                  show-less-items class="mt-3" :showSizeChanger="false">
                  <template #itemRender="{ type, originalElement }">
                    <a v-if="type === 'prev'">Previous</a>
                    <a v-else-if="type === 'next'">Next</a>
                    <component :is="originalElement" v-else></component>
                  </template>
                </a-pagination>
              </div>
            </div>

          </div>
          <div class="d-flex justify-content-center text-center mt-5" v-else>
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Content -->
    <add-userid-face-template-modal ref="addUserIdToFace" @faceAdded="getActivity"></add-userid-face-template-modal>
    <show-location-modal ref="showLocation"></show-location-modal>
    <attendance-modal ref="userAttendance"></attendance-modal>
    <edit-employee-modal ref="editEmployee" @editedUser="getActivity"></edit-employee-modal>
    <add-face-template-modal ref="addface"></add-face-template-modal>
    <face-templates-modal ref="faceTemplates"></face-templates-modal>
    <sick-leave-modal ref="sickLeave"></sick-leave-modal>
    <leaves-admin-modal ref="leaveAdmin" @allLeaves="getActivity"></leaves-admin-modal>
    <sick-leave-details-modal ref="sickLeaveDetails"></sick-leave-details-modal>
    <edit-activity-modal ref="editActivity" @activityUpdated="getActivity"></edit-activity-modal>
    <add-manual-activity-modal @activityAdded="getActivity"></add-manual-activity-modal>
    <employee-report-modal ref="employeeReportModal"></employee-report-modal>
    <reset-password-modal ref="resetPasswordModal"></reset-password-modal>
    <assign-employee-modal ref="assignEmployeeModal" @updated="getActivity"></assign-employee-modal>

    <!-- Image Preview Modal -->
    <div class="modal fade" id="image_preview_modal" tabindex="-1" aria-labelledby="imagePreviewLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="imagePreviewLabel">{{ selectedEmployeeName }}</h5>
            <button type="button" class="btn-close close-btn" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <img :src="selectedImageUrl" alt="Employee Image" class="img-fluid preview-image" />
          </div>
        </div>
      </div>
    </div>

    <!-- Delete Confirmation Modal -->
    <div class="modal fade" id="delete_activity_modal" tabindex="-1" aria-labelledby="deleteActivityLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="deleteActivityLabel">Delete Activity</h5>
            <button type="button" class="btn-close close-btn" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>Are you sure you want to delete this activity?</p>
            <div v-if="activityToDelete">
              <p class="mb-1"><strong>Type:</strong> {{ getActivityTypeLabel(activityToDelete.type) }}</p>
              <p class="mb-1"><strong>User:</strong> {{ getDeleteActivityUserName() }}</p>
              <p class="mb-0"><strong>Time:</strong> {{ activityToDelete.created_at }}</p>
            </div>
            <p class="text-danger mb-0"><small>This action cannot be undone. If deleted in the wrong order, the report will contain errors.</small></p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-outline-danger" @click="onDeleteConfirmed" :disabled="isDeleting">
              <span v-if="!isDeleting">Delete</span>
              <div v-else class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Page Wrapper -->

    <view-banked-time-details-modal ref="viewBankedTimeDetails"></view-banked-time-details-modal>
</template>

<script>
import axios from 'axios';
import dayjs from 'dayjs';
import { Modal } from 'bootstrap';
import { VUE_APP_API_BASE_URL } from "../../../config";
import { getImage, getActivityTypeLabel, formatDateTimeStandardWithTime } from "@/utils/util-funcitons";
import ActionDropdown from "@/components/action-dropdown.vue";
import FaceTemplatesModal from "@/components/modal/face-templates-modal.vue";
import AssignEmployeeModal from "@/components/modal/assign-employee-modal.vue";




import { monitorMixin } from "@/mixins/monitorMixin";
const columns = [
  {
    title: "Image",
    dataIndex: "image_path",
    key: "image_path",
    width: 60,
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    width: 190,
    sorter: {
      compare: (a, b) => {
        a = a.name.toLowerCase();
        b = b.name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Date Time",
    dataIndex: "created_at",
    key: "created_at",
    width: 160,
    // sorter: true,
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
    width: 120,
    // sorter: true,
  },
  {
    title: "User",
    dataIndex: "User",
    key: "User",
    width: 110,
    // sorter: true,
  },
  {
    title: "Location",
    dataIndex: "location",
    key: "location",
    width: 180,
    // sorter: true,
  },
  {
    title: "Edited",
    dataIndex: "is_manually_edited",
    key: "is_manually_edited",
    width: 80,
  },
  {
    title: "Reason",
    dataIndex: "reason",
    key: "reason",
    width: 130,
    ellipsis: true,
  },
  {
    title: "Updated By",
    dataIndex: "updated_by",
    key: "updated_by",
    width: 160,
    ellipsis: true,
  },
  {
    title: "Updated At",
    dataIndex: "updated_at",
    key: "updated_at",
    width: 160,
  },
  {
    title: "Action",
    // sorter: true,
    key: "action",
    width: 70,
  },
];


export default {
  mixins: [monitorMixin],
  components: {
    ActionDropdown,
    FaceTemplatesModal,
    AssignEmployeeModal
  },
  data() {
    const today = new Date();
    const endOfYear = new Date(today.getFullYear(), 11, 31);
    return {
      columns,
      activeContractor: null,
      title: "Activities",
      path: "Dashboard",
      text1: "Activities",
      usersData: [],
      locationIdOptions: [],
      employeeData: [],
      perPage: 50,
      current: 1,
      total: 0,
      employee_code: "",
      employee_name: "",
      company_role_id: "",
      companyId: [],
      loader: false,
      load: false,
      visitorPdfLoad: false,
      type: '',
      selectedUsersFromFilter: [],
      dateRange: {
        start_date: dayjs(today).format('YYYY-MM-DD'),
        end_date: dayjs(endOfYear).format('YYYY-MM-DD'),
      },
      pageSizeOptions: ['50', '100', '150', '200'],
      selectedImageUrl: "",
      selectedEmployeeName: "",
      isDeleting: false,
      activityToDelete: null,
      isManualSearch: false
    };
  },
  computed: {
    isAdmin() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return userInfo && userInfo.is_admin === 1;
    }
  },
  mounted() {
    this.initializeFromQuery();
    this.getActivity(),
      this.getLocationIds(),
      this.getEmployees()
  },

  methods: {
    bankedTimeClicked(record) {
      if(this.$refs.viewBankedTimeDetails) {
        this.$refs.viewBankedTimeDetails.updateValues(record, {});
      }
    },

    getActivityTypeLabel,
    getImage,
    async getLocationIds() {
      await axios.get(`${VUE_APP_API_BASE_URL}/location/all`)
        .then((response) => {
          if (response.data.status) {
            this.locationIdOptions = response.data.data
            this.locationIdOptions.forEach(element => {
              delete element['created_at'];
              delete element['updated_at'];
              delete element['latitude'];
              delete element['longitude'];
              element['text'] = element['name'];
              delete element['name'];
            }
            )
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        })
        .finally(() => {

        });
    },

    getLocationName(id) {
      const location = this.locationIdOptions.find(item => item.id === id);
      return location ? location.text : 'Unrecognized';
    },

    getEmployees() {


      axios.get(`${VUE_APP_API_BASE_URL}/user/user-list`)
        .then((response) => {
          if (response.data.status) {
            this.employeeData = response.data.data;

            this.employeeData.forEach(element => {
              element["text"] = element["first_name"] + " " + element["last_name"];
            });
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        })
        .finally(() => {

        });
    },

    getEmployeeName(id) {
      const name = this.employeeData.find(item => item.id === id);
      return name ? name.text : '-';
    },

    async downloadPdf(data) {
      this.load = true;
      const contractorDetails = {
        name: data.contractor.first_name + ' ' + data.contractor.last_name,
        company: data.contractor_details[0].company_name,
        visiting: this.getEmployeeName(data.contractor_details[0].host_id),
        vehicle: data.contractor_details[0].vehicle_number,
        location: this.getLocationName(data.contractor_details[0].location_id),
        checkIn: data.created_at,
        expectedLeave: this.getExpectedLeaveTime(data.created_at, data.contractor_details[0].visiting_minutes),
        entersProduction: data.questionnaire ? true : false,
        user_image: data.contractor.image ?? '',
        signature: data.contractor_details[0].signature,
        questionnaire: data.questionnaire?.data ?? ''

      };
      axios.post(`${VUE_APP_API_BASE_URL}/contractor-pdf/download`, contractorDetails, {
        responseType: 'blob'
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'contractor_info.pdf');
        document.body.appendChild(link);
        link.click();
      })
        .catch(error => {
          this.$toast.error(error.data.errors || 'Download failed');
          console.error('Download failed:', error);
        })
        .finally(() => {
          this.load = false;
        });
    },

    async downloadVisitorPdf(data) {
      this.visitorPdfLoad = true;
      const visitorDetails = {
        visitor_id: data.visitor_id,
        type: data.type,
        first_name: data.visitor?.first_name ?? '',
        last_name: data.visitor?.last_name ?? '',
        host_id: data.visitor_details?.[0]?.host_id ?? null,
        vehicle_number: data.visitor_details?.[0]?.vehicle_number ?? '',
        company_name: data.visitor_details?.[0]?.company_name ?? '',
        mobile_number: data.visitor?.mobile_number ?? '',
        location_id: data.visitor_details?.[0]?.location_id ?? null,
        checkIn: data.created_at,
        signature: data.visitor_details?.[0]?.signature ?? '',
        questions: data.questionnaire?.data ?? ''
      };
      axios.post(`${VUE_APP_API_BASE_URL}/visitor-pdf/download`, visitorDetails, {
        responseType: 'blob'
      }).then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Visitor_${Date.now()}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      })
        .catch(error => {
          this.$toast.error(error?.data?.errors || 'Download failed');
          console.error('Visitor PDF download failed:', error);
        })
        .finally(() => {
          this.visitorPdfLoad = false;
        });
    },


    getSelectedUsers(data, date) {
      this.selectedUsersFromFilter = data.selectedUsers || null;
      this.dateRange.start_date = date.start_date;
      this.dateRange.end_date = date.end_date;
      this.selectedLocations = data.selectedLocations;
      this.type = data.type;

      if (Object.keys(this.$route.query).length > 0) {
        this.isManualSearch = true;
        this.$router.replace({ path: '/employee/activity', query: {} }).finally(() => {
          setTimeout(() => {
            this.isManualSearch = false;
          }, 500);
        });
      }
      this.current = 1;
      this.getActivity();
    },

    getExpectedLeaveTime(checkIn, expectedLeave) {
      if (!checkIn) return '';

      // Try parsing with DD/MM/YYYY HH:mm format first (common in this app)
      let date = dayjs(checkIn, 'DD/MM/YYYY HH:mm', true);

      // Fallback to default dayjs parsing (handles ISO and other common formats)
      if (!date.isValid()) {
        date = dayjs(checkIn);
      }

      if (!date.isValid()) {
        return 'Invalid Date';
      }

      const minutesToAdd = parseInt(expectedLeave) || 0;
      const resultDate = date.add(minutesToAdd, 'minute').toDate();

      // Format using same format as formatDate: "1/15/26, 7:21 PM"
      return formatDateTimeStandardWithTime(resultDate);
    },

    formatDate(dateString) {
      // If already a Date object, use it directly
      if (dateString instanceof Date) {
        return formatDateTimeStandardWithTime(dateString);
      }
      
      // If not a string, return as-is
      if (typeof dateString !== 'string') {
        return dateString;
      }
      
      const date = new Date(dateString);
      
      // Check if the date is valid
      if (isNaN(date.getTime())) {
        // If invalid date, return the original string
        return dateString;
      }

      // Then specify how you want your dates to be formatted
      // return date.toISOString().replace('T', ' ').substring(0, 19);
      return formatDateTimeStandardWithTime(date);
    },

    addUserIdFace(item) {
      this.$refs.addUserIdToFace.updateValues(item, this.dateRange);
    },

    showLocationClick(item) {
      this.$refs.showLocation.updateValues(item);
    },

    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    getActivity() {
      this.loader = true;
      if (Number(this.perPage) >= this.total) {
        this.current = 1
      }
      const params = {
        per_page: this.perPage,
        user_ids: this.selectedUsersFromFilter,
        start_date: this.dateRange.start_date,
        end_date: this.dateRange.end_date,
        locations_ids: this.selectedLocations,
        type: this.type
      }

      if (this.type === 'visitor' || this.type === 'contractor') {
        delete params.user_ids;
      }

      axios.get(`${VUE_APP_API_BASE_URL}/activity/all-activities?page=${this.current}`, { params: params })
        .then((response) => {
          if (response.data.status) {
            this.usersData = response.data.data.data;
            this.current = response.data.data.current_page;

            this.total = Number(response.data.data.total) || 0;
              this.usersData.forEach(e => {
                let date = e['created_at'];
                e['created_at'] = this.formatDate(date);
                if (e['updated_at']) {
                  e['updated_at'] = this.formatDate(e['updated_at']);
                }
              });
            this.usersData.forEach(element => {
              element["name"] = element["first_name"] + " " + element["last_name"];
            });
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },

    async addUserToBankedTime(userId) {

      await axios.post(`${VUE_APP_API_BASE_URL}/banked-time/user/add`, { user_id: userId })
        .then((response) => {
          if (response.data.status) {
            this.$toast.success(response.data.message);
          } else {
            this.$toast.error(response.data.message || response.data.errors);
          }
        }).catch(function (error) {
          console.log(error);
        });
    },





    editClicked(record) {
      this.$refs.editEmployee.updateValues(record);
    },

    leavesClicked(record) {
      const routeData = this.$router.resolve({ path: '/employee/leaves-employee', query: { id: record.id } });
      window.open(routeData.href, '_blank');
    },

    sickLeaveClicked(record) {
      this.$refs.sickLeave.updateValues(record);
    },

    attendanceClicked(record) {
      const routeData = this.$router.resolve({ path: '/employee/attendance-employee', query: { id: record.id } });
      window.open(routeData.href, '_blank');
    },
    addFaceTemplateClicked(record) {
      this.$refs.addface.updateValues(record);
    },
    faceTemplatesClicked(employee) {
      this.$refs.faceTemplates.showTemplates(employee);
    },

    editActivityClicked(record) {
      this.$refs.editActivity.updateValues(record);
    },

    viewReport(record) {
      this.$refs.employeeReportModal.updateValues(record.id, this.dateRange.start_date, this.dateRange.end_date);
      const modal = new Modal(document.getElementById('employee_report_modal'));
      modal.show();
    },
    resetPasswordClicked(record) {
      this.$refs.resetPasswordModal.updateValues(record);
    },
    assignEmployeeClicked(record) {
      this.$refs.assignEmployeeModal.updateValues(record);
    },

    getDynamicKey(userData) {
      if (userData.user_id) return "user"
      else if (userData.visitor_id) return "visitor"
      else if (userData.contractor_id) return "contractor"
      else return "Unrecognized"
    },

    openImagePreview(record) {
      const dynamicKey = this.getDynamicKey(record);
      if (record.image_path) {
        this.selectedImageUrl = this.getImage(record.image_path);
      } else {
        this.selectedImageUrl = require('../../../assets/img/avatar/avatar-29.png');
      }
      if (record[dynamicKey]) {
        this.selectedEmployeeName = `${record[dynamicKey].first_name} ${record[dynamicKey].last_name}`;
      } else {
        this.selectedEmployeeName = 'Unrecognized';
      }
      const modal = new Modal(document.getElementById('image_preview_modal'));
      modal.show();
    },

    confirmDeleteActivity(activity) {
      this.activityToDelete = activity;
      const modal = new Modal(document.getElementById('delete_activity_modal'));
      modal.show();
    },

    getDeleteActivityUserName() {
      if (!this.activityToDelete) return 'Unknown';
      const dynamicKey = this.getDynamicKey(this.activityToDelete);
      if (this.activityToDelete[dynamicKey]) {
        return `${this.activityToDelete[dynamicKey].first_name} ${this.activityToDelete[dynamicKey].last_name}`;
      }
      return 'Unknown';
    },

    async onDeleteConfirmed() {
      if (!this.activityToDelete) return;
      
      await this.deleteActivity(this.activityToDelete.id);
      
      // Close modal
      const modalEl = document.getElementById('delete_activity_modal');
      const modal = Modal.getInstance(modalEl);
      if (modal) modal.hide();
      
      this.activityToDelete = null;
    },

    async deleteActivity(activityId) {
      this.isDeleting = true;
      
      try {
        const response = await axios.post(`${VUE_APP_API_BASE_URL}/activity/delete`, {
          id: activityId
        });
        
        if (response.data.status) {
          this.$toast.success('Activity deleted successfully');
          await this.getActivity();
        } else {
          this.$toast.error(response.data.message || response.data.errors);
        }
      } catch (error) {
        if (error.response?.status === 403) {
          this.$toast.error('Only admin can delete activities');
        } else {
          this.$toast.error('Failed to delete activity');
        }
      } finally {
        this.isDeleting = false;
      }
    },

    initializeFromQuery() {
      if (this.$route.query.id) {
        const queryId = Array.isArray(this.$route.query.id) ? this.$route.query.id[0] : this.$route.query.id;
        const numericId = Number(queryId);
        
        if (!isNaN(numericId)) {
          this.selectedUsersFromFilter = [numericId];
        } else if (queryId) {
          this.selectedUsersFromFilter = [queryId];
        }
        
        this.type = 'user';
      } else {
        this.selectedUsersFromFilter = [];
        this.type = '';
        this.title = "Activities";
      }
    },


  },
  watch: {
    '$route.query': {
      handler() {
        if (!this.isManualSearch) {
          this.initializeFromQuery();
          this.getActivity();
        }
      },
      deep: true
    }
  }
};
</script>

<style scoped>
:where(.css-dev-only-do-not-override-1hsjdkk).ant-pagination .ant-pagination-prev,
:where(.css-dev-only-do-not-override-1hsjdkk).ant-pagination .ant-pagination-next {
  background-color: #ffffff00 !important;
}

.inline-item {
  display: inline-block;
  margin-right: 2px;
  /* Adjust spacing between items */
}

/* Fix for dropdown menu being clipped by table-responsive overflow */
.table-responsive {
  overflow-x: auto !important;
  overflow-y: visible !important;
}

.responsive-img {
  width: 100%;
  max-width: 100px;
  height: auto;
}

/* .custom-select {
  min-width: 30px;
} */

.custom-select select {
  appearance: none;
  width: 50px;
  font-size: 14px;
  padding: 2px 5px;
  background-color: #fff;
  border: 1px solid #caced1;
  border-radius: 0.25rem;
  color: #000;
  cursor: pointer;
}

.avatar {
  background-color: transparent;
  color: #FFF;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  height: 50px;
  line-height: 34px;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  vertical-align: middle;
  width: 50px;
  position: relative;
  white-space: nowrap;
  margin: 0 10px 0 0;
  border-radius: 50%;
  cursor: pointer;
}

.avatar:hover {
  opacity: 0.8;
}

.preview-image {
  max-height: 70vh;
  object-fit: contain;
  border-radius: 8px;
}

.close-btn {
  background-color: #A6A8A9;
  height: 20px;
  width: 20px;
  border: 1px solid #A6A8A9;
  font-size: 20px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.close-btn:hover {
  background-color: #099bf8;
  color: #ffffff;
  border-color: #099bf8;
}

.close-btn:hover span {
  color: #FFF;
}

.close-btn span {
  color: #373B3E;
}
</style>
